<template>
  <div>
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span :class="['px-4 py-1 rounded-lg font-bold text-xs absolute top-4 right-4', statusClass]">
        {{ $t(`final_settlement.status.${finalSettlement.status}`) }}
      </span>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Solde année en cours" :value="formatPrice(finalSettlement.price)" />
        <StackedField v-if="paid" label="Facture">
          <button @click="handleInvoiceClick" class="text-sm text-blue-400 underline cursor-pointer">
            Lien de la facture
          </button>
        </StackedField>
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";
import { toCamelCase } from "@/utils/utils";

export default {
  props: ["finalSettlement"],
  components: {
    StackedField,
  },
  computed: {
    ...mapGetters("finalSettlements", { settlementIsPaid: "isPaid", settlementStatusClass: "statusClass" }),
    paid() {
      return this.settlementIsPaid(this.finalSettlement);
    },
    statusClass() {
      return this.settlementStatusClass(this.finalSettlement);
    },
  },
  methods: {
    formatPrice,
    ...mapActions("finalSettlements", ["fetchInvoiceUrl"]),
    async handleInvoiceClick() {
      const response = await this.fetchInvoiceUrl({ id: this.finalSettlement.id });
      if (!response?.success) return;

      const invoiceUrl = toCamelCase(response.data).invoiceUrl;
      if (invoiceUrl) window.open(invoiceUrl, "_blank");
    },
  },
};
</script>
